export const sellerData = {
    data() {
        return {
            sellerInfo: {
                id: 18,
                witrinoId: 100,
                polotikId: 273,
                name: "آتلیه خاطرات",
                score: 3,
                phone: ["0513892xxxx", "0915515xxxx", "093047xxxx"],
                email: "khatere.at.gmail.com",
                SocialNetworks: [{ name: "whatsapp", link: "https://wa.me/1XXXXXXXXXX" }, { name: "telegram", link: "https://wa.me/1XXXXXXXXXX" }, { name: "instagram", link: "https://wa.me/1XXXXXXXXXX" }],
                state: { id: 32, name: "خراسان رضوی" },
                city: { id: 14, name: "مشهد" },
                address: "بلوار معلم - صدف 24 - پلاک x",
                location: "15556252,34234234",
                logoImage: "https://picsun.ir/blog/wp-content/uploads/2019/12/maxresdef222ault-1024x576.jpg",
                link: "https://vizitoriii.ir/show/166758602327",
                qrCode: "https://qrcode.tec-it.com/API/QRCode?data=QR+Code+Generator+by+TEC-IT&method=download",
                tags: ["آتلیه", "عکاسی"]
            }
        }
    }
}